import { render, staticRenderFns } from "./DetailsButton.vue?vue&type=template&id=06c2eb20&scoped=true&"
import script from "./DetailsButton.vue?vue&type=script&lang=js&"
export * from "./DetailsButton.vue?vue&type=script&lang=js&"
import style0 from "./DetailsButton.vue?vue&type=style&index=0&id=06c2eb20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c2eb20",
  null
  
)

export default component.exports